import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ProductService } from '../../../../../../admin/src/app/services/product.service';
import { Subscription } from "rxjs";
import { Product } from '../../../../../../admin/src/app/models/product';
import { VideoEntry } from "../../../../../../admin/src/app/models/video-entry";
import { DomSanitizer } from "@angular/platform-browser";
import { MatomoTracker } from "ngx-matomo";

@Component({
  selector: 'app-product-videos',
  templateUrl: './product-videos.component.html'
})
export class ProductVideosComponent implements OnInit, OnDestroy {

  productId: string;

  product: Product;

  sub: Subscription;

  videoUrls = [];

  constructor(
    private route: ActivatedRoute,
    private productSvc: ProductService,
    private sanitizer: DomSanitizer,
    private matomoTracker: MatomoTracker
  ) { }

  ngOnInit(): void {
    this.matomoTracker.trackPageView('Product videos');

    this.sub = this.route.parent.paramMap.subscribe(params => {
      this.productId = params.get('productId');
      this.getProduct();
    });
  }

  ngOnDestroy(): void {
    
  }

  getProduct() {
    this.productSvc.get(this.productId).subscribe(data => {
      this.product = Object.assign({}, data.payload);
      this.videoUrls = [];
      this.product.videos.forEach(video => {
        this.videoUrls.push(this.safeYouTubeUrl(video));
      });
    });
  }

  safeYouTubeUrl(entry: VideoEntry) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(entry.url);
  }
}